var alignment_rtlignore_default = {
  "alignLeft": "zZyxW",
  "textWrapNowrap": "LKD1Y",
  "alignRight": "H75Cv",
  "alignCenter": "v-X38",
  "sizeFullWidth": "e0IdO",
  "renderedInTable": "DPVbb",
  "sizeOriginal": "zVKpH",
  "sizeContent": "ZQgqe",
  "sizeSmall": "hFqJM",
  "sizeSmallCenter": "haor2",
  "flex": "pUPgE",
  "LEFT": "Vl22w",
  "CENTER": "P9P0M",
  "RIGHT": "hPfSw",
  "AUTO": "D4VE2",
  "JUSTIFY": "EWmQ2"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
